import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { LanguageService } from './language.service';

export class SnackBar {
  type: string;
  message: string;
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  private subject = new Subject<SnackBar>();

  constructor(private languages: LanguageService) {}

  getSnackBar(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string, duration = 4, params?: any) {
    this.snackBar('snack-success', message, duration, params);
  }

  error(message: string, duration = 4, params?: any) {
    this.snackBar('snack-error', message, duration, params);
  }

  info(message: string, duration = 4, params?: any) {
    this.snackBar('snack-info', message, duration, params);
  }

  warn(message: string, duration = 4, params?: any) {
    this.snackBar('snack-warning', message, duration, params);
  }

  snackBar(type: string, message: string, duration = 4, params?: any) {
    const value = this.languages.getNestedValue(message, params);
    this.subject.next(<SnackBar>{ type: type, message: value, duration: duration });
  }

  clear() {
    this.subject.next();
  }
}
